import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

const base = (companyId) => `${companyId}/payroll`;

// ─── VACATION BALANCE (Semesterlagen Layer 2 — payroll-owned) ───

// Snapshot for one employee. Omit employeeId to default to the caller's self.
export const getVacationBalance = (companyId, params) =>
  axios.get(getApiUrl(`${base(companyId)}/vacation-balance`), { params, withCredentials: true });

// Bulk — one round-trip for every employee the caller can read. Admin/Owner
// get all active employees; non-privileged callers get just themselves.
export const getVacationBalancesBulk = (companyId, params) =>
  axios.get(getApiUrl(`${base(companyId)}/vacation-balance/bulk`), { params, withCredentials: true });

// Admin write: manual entry of earned/carried/saved days for (employee, year).
export const setVacationBalance = (companyId, data) =>
  axios.put(getApiUrl(`${base(companyId)}/vacation-balance`), data, { withCredentials: true });

// POST body: { year, employeeId?, force? } — omit employeeId for bulk rollout.
export const accrueVacationBalance = (companyId, data) =>
  axios.post(getApiUrl(`${base(companyId)}/vacation-balance/accrue`), data, { withCredentials: true });

// ─── SEMESTERSKULD (liability 2940) ───

export const getSemesterskuldLiability = (companyId, asOf) =>
  axios.get(getApiUrl(`${base(companyId)}/semesterskuld/liability`), {
    params: { asOf }, withCredentials: true,
  });

export const getSemesterskuldAdjustment = (companyId, asOf) =>
  axios.get(getApiUrl(`${base(companyId)}/semesterskuld/adjustment`), {
    params: { asOf }, withCredentials: true,
  });

export const bookSemesterskuld = (companyId, data) =>
  axios.post(getApiUrl(`${base(companyId)}/semesterskuld/book`), data, { withCredentials: true });

// ─── TERMINATION (semesterersättning 3232) ───

export const previewTerminationPayout = (companyId, payslipId, terminationDate) =>
  axios.get(
    getApiUrl(`${base(companyId)}/payslip/${payslipId}/semesterersattning/preview`),
    { params: { terminationDate }, withCredentials: true },
  );

export const applyTerminationPayout = (companyId, payslipId, data) =>
  axios.post(
    getApiUrl(`${base(companyId)}/payslip/${payslipId}/semesterersattning/apply`),
    data,
    { withCredentials: true },
  );

// ─── SÄRSKILD LÖNESKATT (information only — booking goes via template) ───

export const computeSarskildLoneskatt = (companyId, amount) =>
  axios.get(getApiUrl(`${base(companyId)}/sarskild-loneskatt/compute`), {
    params: { amount }, withCredentials: true,
  });

// ─── REIMBURSEMENTS (attach expenses to payroll) ───

export const previewReimbursements = (companyId, payrollId) =>
  axios.get(getApiUrl(`${base(companyId)}/${payrollId}/reimbursements/preview`),
    { withCredentials: true });

export const attachReimbursements = (companyId, payrollId, expenseIds) =>
  axios.post(getApiUrl(`${base(companyId)}/${payrollId}/reimbursements/attach`),
    { expenseIds }, { withCredentials: true });

export const detachReimbursements = (companyId, payrollId, expenseIds) =>
  axios.post(getApiUrl(`${base(companyId)}/${payrollId}/reimbursements/detach`),
    { expenseIds }, { withCredentials: true });
